"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPTUMASKS = void 0;
exports.IPTUMASKS = {
    'minas-gerais': {
        'belo-horizonte': {
            text: '000.000.000.000.0',
            textMask: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/]
        },
        'contagem': {
            text: '20.040.040-1',
            textMask: [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/],
            textMaskFunction: function mask(userInput) {
                var numbers = userInput.match(/\d/g);
                var numberLength = 0;
                if (numbers) {
                    numberLength = numbers.join('').length;
                }
                if (!userInput || numberLength > 9) {
                    return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
                }
                else {
                    return [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/];
                }
            }
        }
    },
    'sao-paulo': {
        'sao-paulo': {
            text: '00000000000-0',
            textMask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/]
        }
    },
    'parana': {
        'curitiba': {
            text: '00000000000-0',
            textMask: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/]
        }
    }
};
//# sourceMappingURL=mask.js.map